import React, { FunctionComponent } from 'react';

const LineBreak: FunctionComponent<{ className?: string }> = ({ className }: { className?: string }) => {
  return (<div className={'break-line ' + className} />);
};

export default LineBreak;

